import { createAdminBondRequestPreviews } from "./AdminBondRequestPreviews";

export const AdminBondRequestPreviewsAll = createAdminBondRequestPreviews("admin_bond_requests_v2");
